<template>
  <div 
    class="base-element-image"
    :style="{
      top: elementInfo.top + 'px',
      left: elementInfo.left + 'px',
      width: elementInfo.width + 'px',
      height: elementInfo.height + 'px',
    }"
  >
    <div
      class="rotate-wrapper"
      :style="{ transform: `rotate(${elementInfo.rotate}deg)` }"
    >
      <div 
        class="element-content"
      >
        <div class="image-content">
          <img 
            :src="elementInfo.imgPath" 
            :draggable="false"
            :style="{
              width: '100%',
            }" 
            @dragstart.prevent
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { PPTCodeElement } from '@/types/slides'

export default defineComponent({
  name: 'base-element-code',
  components: {
  },
  props: {
    elementInfo: {
      type: Object as PropType<PPTCodeElement>,
      required: true,
    },
  },
})
</script>

<style lang="scss" scoped>
.base-element-image {
  position: absolute;
}
.rotate-wrapper {
  width: 100%;
  height: 100%;
}
.element-content {
  width: 100%;
  height: 100%;
  position: relative;

  .image-content {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
  }

  img {
    position: absolute;
  }
}
</style>
